// src/components/ReservePage/ResumenCotizacion.jsx
import {
    Box,
    Grid,
    Card,
    CardContent,
    Typography,
    Button,
  } from "@mui/material";
  
  const ResumenCotizacion = ({ rooms, occupants, totalNights, totalPrice, handleDrawerToggle, formatCurrency, handleReserve }) => {
    return (
      <Box onClick={handleDrawerToggle} sx={{ padding: 2 }}>
        <Grid item xs={12}>
          <Card
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: 3,
              boxShadow: 3,
              borderRadius: 2,
              backgroundColor: "#2F251C",
            }}
          >
            <CardContent>
              <Typography color="#fff" variant="h5" align="center" gutterBottom>
                Resumen de Cotización
              </Typography>
  
              {rooms.map(
                (room) =>
                  occupants[room.id] > 0 && (
                    <Box
                      key={room.id}
                      textAlign="center"
                      marginY={2}
                      padding={2}
                      border={1}
                      borderColor="grey.300"
                      borderRadius={2}
                      sx={{ backgroundColor: "#ffffff" }}
                    >
                      <Typography variant="body2" fontWeight="bold">
                        Habitación {room.type}: {room.room}
                      </Typography>
                      <Typography variant="body2">
                        Precio por noche para persona sola o acompañada: {formatCurrency(room.pricePerNight)}
                      </Typography>
                      <Typography variant="body2">
                        Para {occupants[room.id]} persona/s
                      </Typography>
                      <Typography variant="body2">
                        Durante {totalNights} noches
                      </Typography>
                    </Box>
                  )
              )}
  
              <Typography color="#fff" variant="h5" align="center" marginY={1}>
                Precio total: {formatCurrency(totalPrice)}
              </Typography>
              <Box sx={{ textAlign: "center", color: "#EF2917" }}>
                <Typography sx={{ fontWeight: "bold" }}>
                  *Revisa los datos de la reserva*
                </Typography>
              </Box>
              <Button
                onClick={handleReserve}
                variant="contained"
                color="secondary"
                fullWidth
                sx={{ marginTop: 2 }}
              >
                Ingresa tus Datos
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Box>
    );
  };
  
  export default ResumenCotizacion;
  